import React, {useEffect, useState} from "react";
import {Field, useFormState} from "react-final-form";
import {useSelector} from "react-redux";
import QueryStorage from "../../../../../common/helpers/QueryStorage";

function FreeWriterLevel({ freeSelectedValue, setFreeSelectedValue, resetSelectedValue }) {
    const optionsFree = useSelector(state => state.orderOptions.data.freeWriterLevel);
    const options = useSelector(state => state.orderOptions.data.writerLevel);
    const {values} = useFormState();
    const [isDisabled, setIsDisabled] = useState();
    const {balance} = useSelector(state => state.balance);

    let item = null;
    if (useSelector(state => state.ordersReducer)) {
        item = useSelector(state => state.ordersReducer.item);
    }

    let isFreePremiumWriterYet = item && item.is_free_author_category_id === 'Free Premium';
    let isFreeAdvancedWriterYet = item && item.is_free_author_category_id === 'Free Advanced';

    const handleRadioChange = (e) => {
        values.authorCategory = undefined;
        setFreeSelectedValue(e.target.value);
        QueryStorage.remove("authorCategory");
        resetSelectedValue();
    };

    useEffect(() => {
        setIsDisabled(values.authorCategory === options.preferredWriter.value);
    }, [values.authorCategory])

    useEffect(() => {
        setIsDisabled(values.authorCategory === options.preferredWriter.value);
    }, [values.freeAuthorCategory]);

    return values.authorCategory !== options.preferredWriter.value &&
    ((isFreePremiumWriterYet || isFreeAdvancedWriterYet) || (balance && (balance.adv_count > 0 || balance.enl_count > 0))) ? <div className="form-group">
        <div className="form-label">Your Bonus options</div>
        <div className="wt-level-items">
            {isFreeAdvancedWriterYet || (balance && balance.adv_count > 0) ? <label className={`wt-level-item wt-level-item-2 ${freeSelectedValue === optionsFree.freeAuthorCategoryAdvanced.value ? 'wt-level-item-selected' : ''}`} style={isDisabled ? {pointerEvents: 'none'} : {}}>
                <div className="wt-level-item__icon"><img src="/_core/assets/themes/v5/assets/img/form3/feature_free.svg" alt=""/></div>
                <div className="wt-level-item__rating">
                    <img src="/_core/assets/themes/v5/assets/img/form3/star-new.svg" alt=""/>
                    <img src="/_core/assets/themes/v5/assets/img/form3/star-new.svg" alt=""/>
                </div>
                <h5 className="wt-level-item__title">{optionsFree.freeAuthorCategoryAdvanced.label}</h5>
                <div className="wt-level-item__info">
                    Free
                </div>
                <div className="wt-level-item__descr">
                    <p>
                        Experienced writer with a high satisfaction rate.
                        Much larger experience in writing, experience in assignments.
                    </p>
                </div>
                <Field
                    name="freeAuthorCategory"
                    type="radio"
                    component="input"
                    value={optionsFree.freeAuthorCategoryAdvanced.value}
                    disabled={isDisabled}
                    onClick={handleRadioChange}
                />
                <span className="checkbox-default__checkmark">
                    <div className="checkbox-default__checkmark-icon">
                        <img src="/_core/assets/themes/v5/assets/img/form3/default-check-icon.svg" alt=""/>
                    </div>
                </span>
            </label> : ''}
            {isFreePremiumWriterYet || (balance && balance.enl_count > 0) ? <label className={`wt-level-item wt-level-item-3 ${freeSelectedValue === optionsFree.freeAuthorCategoryPremium.value ? 'wt-level-item-selected' : ''}`} style={isDisabled ? {pointerEvents: 'none'} : {}}>
                <div className="wt-level-item__icon"><img src="/_core/assets/themes/v5/assets/img/form3/feature_free.svg" alt=""/></div>
                <div className="wt-level-item__rating">
                    <img src="/_core/assets/themes/v5/assets/img/form3/star-new.svg" alt=""/>
                    <img src="/_core/assets/themes/v5/assets/img/form3/star-new.svg" alt=""/>
                    <img src="/_core/assets/themes/v5/assets/img/form3/star-new.svg" alt=""/>
                </div>
                <h5 className="wt-level-item__title">{optionsFree.freeAuthorCategoryPremium.label}</h5>
                <div className="wt-level-item__info">
                    Free
                </div>
                <div className="wt-level-item__descr">
                    <p>
                        Top quality writer from an English speaking country. Advanced vocabulary and
                        style
                        of writing.
                    </p>
                </div>
                <Field
                    name="freeAuthorCategory"
                    type="radio"
                    component="input"
                    value={optionsFree.freeAuthorCategoryPremium.value}
                    disabled={isDisabled}
                    onClick={handleRadioChange}
                />
                <span className="checkbox-default__checkmark">
                    <div className="checkbox-default__checkmark-icon">
                        <img src="/_core/assets/themes/v5/assets/img/form3/default-check-icon.svg" alt=""/>
                    </div>
                </span>
            </label> : ''}
        </div>
    </div> : '';
}

export default FreeWriterLevel;